/* eslint-disable react/prop-types */
import { useHeaderContext } from '@/sinister/header/contexts/HeaderContext'
import { Dropdown } from 'antd'
import styled from 'styled-components'
import IconOpen from '../common/IconOpen'
import Link from './decorators/Link'
import MenuDropdown from './decorators/MenuDropdown'
import Text from './decorators/Text'

const StyledButtonDropdown = styled.button`
  grid-area: helper;
  cursor: pointer;
  background-color: transparent;
  border: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  & > span {
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`

const HelperLayout = ({ parsedHelpers = [] }) => {
  const { colorSubheader: color, help, helpV3 } = useHeaderContext()

  if (!parsedHelpers.length || !help?.show) {
    return null
  }
  if (parsedHelpers.length === 1) {
    const helper = parsedHelpers[0] as { href: string; text: string }
    return <Link color={color} href={helper.href} text={helper.text} />
  }

  const text = helpV3?.label ? helpV3?.label : `${help?.title} ${help?.message}`

  return (
    <Dropdown
      dropdownRender={() => <MenuDropdown items={parsedHelpers} />}
      trigger={['click']}
      placement="bottom"
      getPopupContainer={(triggerNode) =>
        triggerNode.parentElement || triggerNode
      }
    >
      <StyledButtonDropdown>
        <Text text={text} color={color} />
        <IconOpen />
      </StyledButtonDropdown>
    </Dropdown>
  )
}

export default HelperLayout
